<div class="footer">
  <p>
    ©2024–{{ year | date: "yyyy" }} Oleh Rumyk ·
    <a href="mailto:o.rumyk@gmail.com">o.rumyk@gmail.com</a> ·
    <a href="https://www.linkedin.com/in/oleh-rumyk-a13659219/" target="_blank" rel="noopener">LinkedIn</a> ·
    v{{ appVersion }}
  </p>
</div>
